module.exports = __webpack_public_path__ + "img/Geek.c0d5d24c.png";